(function () {
  const drawer = document.getElementById('mobile-nav-drawer');
  const openButton = document.getElementById('mobile-nav-drawer-open');
  const closeButton = document.getElementById('mobile-nav-drawer-close');
  const mainNavMenu = document.getElementById('main-nav-menu');
  const menuToggles = document.querySelectorAll('[data-menu-toggle]');
  const menuTargets = document.querySelectorAll('[data-menu-target]');
  const brandsMenu = document.querySelector('[data-menu-target="brands-menu-desktop"]');

  /** Below `mdlrg` (tailwind.config.js) parent nav buttons open the mobile drawer to the matching department panel. */
  const MOBILE_PARENT_NAV_MAX_WIDTH_PX = 1224;

  /**
   * Desktop mega menu open behaviour from header section setting.
   * @returns {'hover' | 'click'}
   */
  function getMegaMenuTriggerMode() {
    const header = document.querySelector('header[data-mega-menu-trigger]');
    if (!header) return 'hover';
    return header.getAttribute('data-mega-menu-trigger') === 'click' ? 'click' : 'hover';
  }

  /**
   * Inner mega menu category tab behaviour from header section setting.
   * @returns {'hover' | 'click'}
   */
  function getMegaMenuChildTabTriggerMode() {
    const header = document.querySelector('header[data-mega-menu-child-tab-trigger]');
    if (!header) return 'hover';
    return header.getAttribute('data-mega-menu-child-tab-trigger') === 'click' ? 'click' : 'hover';
  }

  /**
   * Viewport where the hamburger / mobile drawer pattern applies (same as max-mdlrg).
   * @returns {boolean}
   */
  function isMobileParentNavViewport() {
    return window.matchMedia('(max-width: ' + MOBILE_PARENT_NAV_MAX_WIDTH_PX + 'px)').matches;
  }

  /**
   * Set the visibility of the mobile nav drawer
   * @param {boolean} visible - Whether the drawer should be visible
   * @returns {void}
   */
  function setDrawerVisibility(visible) {
    if (!drawer || !openButton) return;
    if (visible) {
      drawer.setAttribute('aria-hidden', 'false');
      drawer.setAttribute('data-open', 'true');
      openButton.setAttribute('aria-expanded', 'true');
      // Prevent body scrolling when drawer is open
      document.body.style.overflow = 'hidden';
      // Small delay to ensure the transition works
      setTimeout(() => {
        drawer.focus();
      }, 50);
    } else {
      drawer.setAttribute('aria-hidden', 'true');
      drawer.setAttribute('data-open', 'false');
      openButton.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      openButton.focus();
      resetMobileNavDrawerState();
    }
  }

  /**
   * Find mega opener button by panel element id (avoid fragile CSS attribute selectors).
   * @param {HTMLElement} root
   * @param {string} panelId
   * @returns {HTMLElement | null}
   */
  function findMobileMegaOpenerByPanelId(root, panelId) {
    if (!panelId || !root) return null;
    var want = String(panelId).trim();
    var buttons = root.querySelectorAll('.js-mobile-nav-open-mega');
    for (var i = 0; i < buttons.length; i++) {
      var ac = buttons[i].getAttribute('aria-controls');
      if (ac != null && ac.trim() === want) return buttons[i];
    }
    return null;
  }

  /**
   * Build mobile nav child panel id from header section + menu handle.
   * @param {string} menuId
   * @returns {string | null}
   */
  function getMobileChildPanelId(menuId) {
    if (!drawer || !menuId) return null;
    var sectionId = drawer.getAttribute('data-header-section-id');
    if (!sectionId) return null;
    return 'mobile-nav-child-' + sectionId.trim() + '-' + String(menuId).trim();
  }

  /**
   * Open a department panel inside the mobile nav drawer (level 2).
   * @param {string} childPanelId
   * @returns {boolean}
   */
  function openMobileNavChildPanel(childPanelId) {
    if (!drawer || !childPanelId) return false;

    childPanelId = childPanelId.trim();
    var childPanel = document.getElementById(childPanelId);
    if (!childPanel || !drawer.contains(childPanel)) return false;

    var rootEl = drawer.querySelector('.js-mobile-nav-level-root');
    if (rootEl) rootEl.setAttribute('data-active', 'false');

    drawer.querySelectorAll('.js-mobile-nav-level-child').forEach(function (p) {
      p.setAttribute('data-active', p === childPanel ? 'true' : 'false');
    });

    drawer.querySelectorAll('.js-mobile-nav-mega-layer').forEach(function (m) {
      m.dataset.mobileMegaOpen = 'false';
      m.setAttribute('aria-hidden', 'true');
    });
    drawer.querySelectorAll('.js-mobile-nav-open-mega').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
    });

    return true;
  }

  /**
   * Reset mobile drawer drill-down (root / child / mega) without closing drawer.
   * @returns {void}
   */
  function resetMobileNavDrawerState() {
    if (!drawer) return;

    var root = drawer.querySelector('.js-mobile-nav-level-root');
    if (root) root.setAttribute('data-active', 'true');

    drawer.querySelectorAll('.js-mobile-nav-level-child').forEach(function (panel) {
      panel.setAttribute('data-active', 'false');
    });

    drawer.querySelectorAll('.js-mobile-nav-mega-layer').forEach(function (layer) {
      layer.dataset.mobileMegaOpen = 'false';
      layer.setAttribute('aria-hidden', 'true');
      var cid = layer.id;
      var opener = cid && findMobileMegaOpenerByPanelId(drawer, cid);
      if (opener) opener.setAttribute('aria-expanded', 'false');
    });
  }

  /**
   * Three-level mobile nav: div layers + buttons (root list → department panel → mega panel).
   */
  function initMobileNavDrawerLevels() {
    if (!drawer) return;

    drawer.addEventListener('click', function (evt) {
      var openChildBtn = evt.target.closest('.js-mobile-nav-open-child');
      if (openChildBtn && drawer.contains(openChildBtn)) {
        evt.preventDefault();
        var childPanelId = openChildBtn.getAttribute('data-mobile-nav-child-panel');
        if (childPanelId) openMobileNavChildPanel(childPanelId);
        return;
      }

      var backRootBtn = evt.target.closest('.js-mobile-nav-back-root');
      if (backRootBtn && drawer.contains(backRootBtn)) {
        evt.preventDefault();
        resetMobileNavDrawerState();
        return;
      }

      var openMegaBtn = evt.target.closest('.js-mobile-nav-open-mega');
      if (openMegaBtn && drawer.contains(openMegaBtn)) {
        evt.preventDefault();
        var megaId = openMegaBtn.getAttribute('aria-controls');
        if (!megaId) return;
        megaId = megaId.trim();
        var megaEl = document.getElementById(megaId);
        if (!megaEl || !drawer.contains(megaEl) || !megaEl.classList.contains('js-mobile-nav-mega-layer')) return;

        drawer.querySelectorAll('.js-mobile-nav-mega-layer').forEach(function (other) {
          if (other === megaEl) return;
          other.dataset.mobileMegaOpen = 'false';
          other.setAttribute('aria-hidden', 'true');
          var oid = other.id;
          var ob = oid && findMobileMegaOpenerByPanelId(drawer, oid);
          if (ob) ob.setAttribute('aria-expanded', 'false');
        });

        megaEl.dataset.mobileMegaOpen = 'true';
        megaEl.setAttribute('aria-hidden', 'false');
        openMegaBtn.setAttribute('aria-expanded', 'true');
        return;
      }

      var backMegaBtn = evt.target.closest('.js-mobile-nav-back-mega');
      if (backMegaBtn && drawer.contains(backMegaBtn)) {
        evt.preventDefault();
        var megaLayer = backMegaBtn.closest('.js-mobile-nav-mega-layer');
        if (!megaLayer || !drawer.contains(megaLayer)) return;
        megaLayer.dataset.mobileMegaOpen = 'false';
        megaLayer.setAttribute('aria-hidden', 'true');
        var mid = megaLayer.id;
        var op = mid && findMobileMegaOpenerByPanelId(drawer, mid);
        if (op) op.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /**
   * Manage hiding header elements on scroll
   * @returns {void}
   */
  function initScrollEvents() {
    window.wasScrollingUp = false;

    const scrollThreshold = getComputedStyle(document.documentElement)
      .getPropertyValue('--header-height')
      .replace('px', '');

    window.addEventListener('scroll', () => {
      const posY = document.documentElement.scrollTop;
      const isScrollingUp = posY < (window.lastScrollTop || 0);

      // Store current scroll position for next comparison
      window.lastScrollTop = posY;

      if (isScrollingUp) {
        document.body.classList.remove('header--hidden');
      } else if (posY > scrollThreshold) {
        document.body.classList.add('header--hidden');
      }

      if (window.innerWidth > 990) {
        // Update header height based on the direction of the scroll, since we are using transform to hide the sub menu
        updateHeaderHeight(isScrollingUp ? 'header' : 'header > div.js-main-nav-menu');
      }
    });
  }

  /**
   * Set the header height CSS variable
   * @returns {void}
   */
  function updateHeaderHeight(elem = undefined) {
    const header = elem !== undefined ? document.querySelector(elem) : document.querySelector('header');
    if (header) {
      const headerHeight = header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    }
  }

  /**
   * Initialize header height tracking with ResizeObserver
   * @returns {void}
   */
  function initHeaderHeightTracking() {
    const header = document.querySelector('header');
    if (!header) return;

    // Set initial header height
    updateHeaderHeight();

    // Create ResizeObserver to watch for header size changes
    const resizeObserver = new ResizeObserver(() => {
      updateHeaderHeight();
    });

    // Start observing the header element
    resizeObserver.observe(header);

    // Also listen for window resize events as a fallback
    window.addEventListener('resize', () => updateHeaderHeight());

    // Listen for orientation changes on mobile devices
    window.addEventListener('orientationchange', () => {
      // Small delay to ensure layout has updated
      setTimeout(updateHeaderHeight, 100);
    });
  }

  /**
   * Mega menu horizontal scroll arrows (only when sticky header is enabled — see header data-sticky-header)
   * @returns {void}
   */
  function initMegaMenuScroll() {
    if (!document.querySelector('header[data-sticky-header="true"]')) return;

    document.querySelectorAll('[data-menu-target]').forEach((menuContainer) => {
      const scrollable = menuContainer.querySelector('.mega-menu-scrollable');
      const leftBtn = menuContainer.querySelector('.mega-menu-scroll-left');
      const rightBtn = menuContainer.querySelector('.mega-menu-scroll-right');

      if (!scrollable || !leftBtn || !rightBtn) return;

      const hasContent = scrollable.children.length > 0;

      if (!hasContent) {
        leftBtn.style.display = 'none';
        rightBtn.style.display = 'none';
        return;
      }

      function updateScrollButtons() {
        if (menuContainer.dataset.active === 'false') return;

        const scrollLeft = scrollable.scrollLeft;
        const scrollWidth = scrollable.scrollWidth;
        const clientWidth = scrollable.clientWidth;

        if (scrollWidth <= clientWidth) {
          leftBtn.classList.add('opacity-0', 'pointer-events-none');
          rightBtn.classList.add('opacity-0', 'pointer-events-none');
          return;
        }

        if (scrollLeft > 0) {
          leftBtn.classList.remove('opacity-0', 'pointer-events-none');
          leftBtn.classList.add('opacity-100');
        } else {
          leftBtn.classList.add('opacity-0', 'pointer-events-none');
          leftBtn.classList.remove('opacity-100');
        }

        if (scrollLeft < scrollWidth - clientWidth - 1) {
          rightBtn.classList.remove('opacity-0', 'pointer-events-none');
          rightBtn.classList.add('opacity-100');
        } else {
          rightBtn.classList.add('opacity-0', 'pointer-events-none');
          rightBtn.classList.remove('opacity-100');
        }
      }

      const scrollAmount = 200;

      leftBtn.addEventListener('click', () => {
        scrollable.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });

      rightBtn.addEventListener('click', () => {
        scrollable.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });

      scrollable.addEventListener('scroll', updateScrollButtons);

      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'data-active') {
            updateScrollButtons();
          }
        });
      });

      observer.observe(menuContainer, { attributes: true });

      updateScrollButtons();

      window.addEventListener('resize', updateScrollButtons);
    });
  }

  function activateTabs(tabs, targetTab, getPanelFn) {
    tabs.forEach(function (tab, index) {
      const panel = getPanelFn(tab);
      const isActive = targetTab != null && tab === targetTab;

      tab.dataset.active = isActive ? 'true' : 'false';
      tab.setAttribute('aria-selected', String(isActive));

      /** @type {'0' | '-1'} */
      let tabIndex = '-1';
      if (isActive) {
        tabIndex = '0';
      } else if (targetTab == null && index === 0) {
        // No tab selected: first tab stays focusable for keyboard (roving tabindex)
        tabIndex = '0';
      }
      tab.setAttribute('tabindex', tabIndex);

      if (panel) {
        panel.dataset.active = isActive ? 'true' : 'false';
        panel.setAttribute('aria-hidden', String(!isActive));
      }
    });
  }

  function addKeyboardNav(tabListEl, tabs, getPanelFn, orientation) {
    const prevKey = orientation === 'vertical' ? 'ArrowUp' : 'ArrowLeft';
    const nextKey = orientation === 'vertical' ? 'ArrowDown' : 'ArrowRight';

    tabListEl.addEventListener('keydown', function (e) {
      const idx = tabs.indexOf(document.activeElement);
      if (idx === -1) return;

      let next;
      if (e.key === nextKey) {
        next = (idx + 1) % tabs.length;
      } else if (e.key === prevKey) {
        next = (idx - 1 + tabs.length) % tabs.length;
      } else if (e.key === 'Home') {
        next = 0;
      } else if (e.key === 'End') {
        next = tabs.length - 1;
      } else {
        return;
      }

      e.preventDefault();
      tabs[next].focus();
      activateTabs(tabs, tabs[next], getPanelFn);
    });
  }

  function getPanelForOuterMegaTab(tab) {
    return tab.parentElement ? tab.parentElement.querySelector('div[data-menu-target]') : null;
  }

  /**
   * Collapse all desktop parent mega panels (horizontal tabs).
   * @returns {void}
   */
  function closeOuterMegaMenuTabs() {
    const nav = document.getElementById('main-nav-parent-links');
    if (!nav) return;
    const tabListEl = nav.querySelector('.mega-menu-scrollable');
    if (!tabListEl) return;
    const tabs = Array.from(tabListEl.querySelectorAll('button[data-menu-id]'));
    if (!tabs.length) return;
    activateTabs(tabs, null, getPanelForOuterMegaTab);
  }

  function initMainNavMenuClosesMega() {
    const topBar = document.querySelector('.js-main-nav-menu');
    if (!topBar) return;
    topBar.addEventListener('click', function () {
      closeOuterMegaMenuTabs();
    });
  }

  function openOuterMegaTab(tabs, tab, panel) {
    activateTabs(tabs, tab, getPanelForOuterMegaTab);
    if (panel) initInnerTabs(panel);
  }

  function initOuterTabs() {
    const nav = document.getElementById('main-nav-parent-links');
    if (!nav) return;

    const tabListEl = nav.querySelector('.mega-menu-scrollable');
    if (!tabListEl) return;

    const tabs = Array.from(tabListEl.querySelectorAll('button[data-menu-id]'));
    if (!tabs.length) return;

    const triggerMode = getMegaMenuTriggerMode();

    tabListEl.setAttribute('role', 'tablist');
    tabListEl.setAttribute('aria-label', 'Product categories');

    tabs.forEach(function (tab) {
      const id = tab.dataset.menuId;
      const tabId = 'mega-tab-' + id;
      const panelId = 'mega-panel-' + id;
      const panel = getPanelForOuterMegaTab(tab);
      const useOuterTabpanel = panel && panel.hasAttribute('data-outer-tabpanel');
      const navItem = tab.parentElement;

      tab.setAttribute('role', 'tab');
      tab.id = tabId;
      if (useOuterTabpanel) {
        tab.setAttribute('aria-controls', panelId);
      } else {
        tab.removeAttribute('aria-controls');
      }

      if (panel) {
        if (useOuterTabpanel) {
          panel.setAttribute('role', 'tabpanel');
          panel.id = panelId;
          panel.setAttribute('aria-labelledby', tabId);
          panel.setAttribute('tabindex', '0');
        } else {
          panel.removeAttribute('role');
          panel.removeAttribute('id');
          panel.removeAttribute('aria-labelledby');
          panel.removeAttribute('tabindex');
        }
      }

      if (triggerMode === 'hover' && navItem) {
        navItem.addEventListener('mouseenter', function () {
          if (isMobileParentNavViewport()) return;
          openOuterMegaTab(tabs, tab, panel);
        });

        navItem.addEventListener('mouseleave', function () {
          if (isMobileParentNavViewport()) return;
          closeOuterMegaMenuTabs();
        });
      }

      tab.addEventListener('click', function (evt) {
        if (isMobileParentNavViewport()) {
          evt.preventDefault();
          evt.stopPropagation();

          var childPanelId = tab.getAttribute('data-mobile-nav-child-panel');
          if (!childPanelId) {
            childPanelId = getMobileChildPanelId(tab.getAttribute('data-menu-id'));
          }

          setDrawerVisibility(true);
          if (childPanelId) {
            openMobileNavChildPanel(childPanelId);
          }
          return;
        }

        if (triggerMode !== 'click') return;

        if (tab.dataset.active === 'true') {
          closeOuterMegaMenuTabs();
          return;
        }
        openOuterMegaTab(tabs, tab, panel);
      });
    });

    addKeyboardNav(tabListEl, tabs, getPanelForOuterMegaTab, 'horizontal');

    const initiallyActive = tabs.find(function (t) {
      return t.dataset.active === 'true';
    });
    // Do not fall back to tabs[0] — that was opening the first mega menu on load.
    activateTabs(tabs, initiallyActive !== undefined ? initiallyActive : null, getPanelForOuterMegaTab);
  }

  function initInnerTabs(outerPanel) {
    const tabListEls = outerPanel.querySelectorAll('[role="tablist"][aria-orientation="vertical"]');

    tabListEls.forEach(function (tabListEl) {
      if (tabListEl.dataset.innerTabsReady) return;
      tabListEl.dataset.innerTabsReady = 'true';

      const tabs = Array.from(tabListEl.querySelectorAll('button[data-child-tab]'));
      if (!tabs.length) return;

      const panelContainer = tabListEl.parentElement;
      const triggerMode = getMegaMenuChildTabTriggerMode();

      function getPanelForInnerTab(tab) {
        const key = tab.dataset.childTab;
        return panelContainer ? panelContainer.querySelector('[data-child-panel="' + key + '"]') : null;
      }

      tabs.forEach(function (tab) {
        if (triggerMode === 'hover') {
          tab.addEventListener('mouseenter', function () {
            if (isMobileParentNavViewport()) return;
            activateTabs(tabs, tab, getPanelForInnerTab);
          });
        }

        tab.addEventListener('click', function () {
          if (triggerMode !== 'click') return;
          activateTabs(tabs, tab, getPanelForInnerTab);
        });
      });

      addKeyboardNav(tabListEl, tabs, getPanelForInnerTab, 'vertical');

      const initiallyActive =
        tabs.find(function (t) {
          return t.dataset.active === 'true';
        }) || tabs[0];
      activateTabs(tabs, initiallyActive, getPanelForInnerTab);
    });
  }

  /**
   * Desktop mega menu tab panels (horizontal parent nav + vertical child tabs)
   * @returns {void}
   */
  function initDesktopMegaMenu() {
    initOuterTabs();

    const nav = document.getElementById('main-nav-parent-links');
    if (nav) {
      const activePanel = nav.querySelector('div[data-menu-target][data-active="true"]');
      if (activePanel) initInnerTabs(activePanel);
    }

    initMegaMenuScroll();
  }

  /**
   * Initialize the mobile nav drawer open/close logic
   * @returns {void}
   */
  document.addEventListener('DOMContentLoaded', function () {
    if (openButton) {
      openButton.addEventListener('click', function () {
        setDrawerVisibility(true);
      });
    }

    if (closeButton) {
      closeButton.addEventListener('click', function () {
        setDrawerVisibility(false);
      });
    }

    initMobileNavDrawerLevels();
    initHeaderHeightTracking();
    initScrollEvents();
    initDesktopMegaMenu();
    initMainNavMenuClosesMega();
  });
})();
